import { API_HOST } from '@/config';
import { OnboardingDetails } from './types';
import client, { ApiRoutes } from '@/store/client';

const getStages = () =>
  client.get<OnboardingDetails>(
    `${API_HOST}/${ApiRoutes.Core}/onboarding/features/INSIDE`,
  );
export default { getStages };
